import { render, staticRenderFns } from "./MemberView.vue?vue&type=template&id=3545bf66&"
import script from "./MemberView.vue?vue&type=script&lang=js&"
export * from "./MemberView.vue?vue&type=script&lang=js&"
import style0 from "./MemberView.vue?vue&type=style&index=0&id=3545bf66&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports